export const calculatorBlocks = {
  profileUrl: 'https://wordpress.org/plugins/calculator-blocks/'
};
export default {
  calculatorBlocks
};